import { render, staticRenderFns } from "./BringgTrackingButton.vue?vue&type=template&id=222a909c&scoped=true"
import script from "./BringgTrackingButton.vue?vue&type=script&lang=js"
export * from "./BringgTrackingButton.vue?vue&type=script&lang=js"
import style0 from "./BringgTrackingButton.vue?vue&type=style&index=0&id=222a909c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a909c",
  null
  
)

export default component.exports